import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import {
    FormControl,
    Validators,
    FormGroup,
    FormControlStatus,
} from '@angular/forms'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import { environment } from '../../environments/environment'
import { CallerService } from '../services/caller.service'
import { setCorpMemberProfileData } from '../ngrx-store/actions/corp-member.actions'

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
})
export class SignupComponent implements OnInit {
    @ViewChild('passwordInput') passwordInput!: ElementRef
    constructor(
        private route: ActivatedRoute,
        private callerService: CallerService, private router: Router) {}

    selected_state_lgas: string[] = []

    passwordInputIcon: string = 'visibility'

    isSigningUp: boolean = false

    // regex for email validation
    email_regex: RegExp = /^[\w\-\.\+]+@([\w\-]+\.)+[\w\-]{2,4}$/i

    signupForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.pattern(this.email_regex)]),
        state_code: new FormControl('', [
            Validators.required,
            Validators.pattern(this.callerService.state_code_regex),
        ]),
        password: new FormControl('', [
            Validators.required,
            Validators.minLength(6),
        ]),
        // first_name: new FormControl('', [
        //   // Validators.required,
        //   // Validators.minLength(2)
        // ]),
        // middle_name: new FormControl('', [
        //   Validators.minLength(2)
        // ]),
        // last_name: new FormControl('', [
        //   // Validators.required,
        //   // Validators.minLength(2)
        // ]),
        lga: new FormControl({ value: '', disabled: true }, [
            Validators.required,
        ]),
        ref_code: new FormControl(''),
    })

    ngOnInit() {
        const ref_code = this.route.snapshot.queryParamMap.get('ref')
        if (ref_code) {
            this.signupForm.get('ref_code')?.setValue(ref_code)
        }
        
        this.signupForm
            .get('state_code')
            ?.statusChanges.subscribe((statusValidity: FormControlStatus) => {
                console.log('statusValidity', statusValidity)
                if (statusValidity === 'VALID') {
                    // enable LGA input
                    this.signupForm.get('lga')?.enable()

                    // update the lga options based on the state in the state code
                    const state_short = this.signupForm
                        .get('state_code')
                        ?.value?.substring(0, 2)
                        ?.toUpperCase()
                    // get the index of the short state code from the state_code_short array
                    if (typeof state_short === 'string') {
                        const _index =
                            this.callerService.states_short.indexOf(state_short)
                        // get the long name from the states long names array
                        const state_long_name =
                            this.callerService.states_long[_index]

                        // then fetch the LGAs using the state_long_name as key for the LGA object
                        if (
                            state_long_name in
                            this.callerService.states_long_lgas
                        ) {
                            // @ts-ignore
                            this.selected_state_lgas =
                                // @ts-ignore
                                this.callerService.states_long_lgas?.[
                                    state_long_name
                                ]
                        }
                    }
                } else {
                    // disable the LGA input, and empty the options.
                    this.signupForm.get('lga')?.disable()
                    this.selected_state_lgas = []
                }
            })
    }

    signUp() {
        console.log(this.signupForm.value)
        if (this.signupForm.valid) {
            this.isSigningUp = true
            this.callerService.signUp(this.signupForm.value).subscribe(
                (res: any) => {
                    // @todo: make sure we get a response, for now it's nothing. once it's success, we good
                    console.log('result', res)

                    this.isSigningUp = false
                    localStorage.setItem(
                        CallerService.LOCAL_STORAGE_DATA_KEY,
                        JSON.stringify(res.body.result),
                    )

                    if (res.body.token) {
                        sessionStorage.setItem(CallerService.SESSION_STORAGE_DATA_KEY, res.body.token);
                    }

                    this.callerService.store.dispatch(setCorpMemberProfileData({data: res.body.result}))
                    this.router.navigate(['/home'])
                },
                (err: HttpErrorResponse) => {
                    console.log('err', err)

                    this.isSigningUp = false
                    this.callerService.showNotification(
                        err?.error?.message ?? 'An error occurred',
                    )
                },
                () => {
                    console.log('completed the http signup')
                },
            )
        } else {
            console.log('sign up form errors', this.signupForm)
        }
    }

    togglePasswordInputIcon(): void {
        if (this.passwordInputIcon == 'visibility') {
            this.passwordInputIcon = 'visibility_off'
            this.passwordInput.nativeElement.type = 'text'
        } else {
            this.passwordInputIcon = 'visibility'
            this.passwordInput.nativeElement.type = 'password'
        }
    }
}
